import { render, staticRenderFns } from "./service-detail-administration.vue?vue&type=template&id=41af4244&scoped=true"
import script from "./service-detail-administration.vue?vue&type=script&lang=js"
export * from "./service-detail-administration.vue?vue&type=script&lang=js"
import style0 from "./service-detail-administration.vue?vue&type=style&index=0&id=41af4244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af4244",
  null
  
)

export default component.exports